// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sobrescribir estilos del Material Dialog */
::ng-deep .mat-mdc-dialog-surface,
::ng-deep .mdc-dialog__surface {
    background-color: #181B25 !important;
    padding: 0 !important;
    margin: 0 !important;
}

::ng-deep .mat-mdc-dialog-container {
    background-color: #181B25 !important;
    padding: 0 !important;
}

::ng-deep .cdk-overlay-pane {
    background-color: #181B25 !important;
}

.datail-container {
    background-color: #181B25;
    min-height: 100vh;
    padding: 0;
    color: #ffffff;
}

.datail-container-inner {
    background-color: #181B25;
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px 40px;
}

.gallery {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto 45px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);
}

.gallery .carousel-inner {
    width: 100%;
    max-height: 600px;
    overflow: hidden;
}

.gallery .carousel-inner .carousel-item {
    width: 100%;
    height: 600px;
}

.custom-margin {
    margin-left: 15px;
}

.gallery .carousel-inner .carousel-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.datail-container .location {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 30px;
}

.datail-container .location > div {
    overflow: hidden;
    padding: 0;
}

.datail-container .location > div:first-child {
    width: 30%;
    flex-shrink: 0;
}

.datail-container .location > div:last-child {
    width: 70%;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.datail-container .location > div:first-child iframe {
    min-height: 300px;
}

.datail-container .location iframe {
    width: 100%;
    height: 100%;
    min-height: 300px;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
}

.location-address {
    margin-bottom: 20px;
    text-align: right;
}

.location-address p {
    color: #ffffff;
    font-size: 1rem;
    line-height: 1.5;
    text-align: right;
}

.location-divider {
    border: none;
    border-top: 1px solid #f09502 !important;
    margin: 20px 0;
    opacity: 0.6;
}

.location-description {
    color: #ffffff;
    line-height: 1.8;
}

.location-description * {
    color: #ffffff !important;
}

.datail-container .location hr.inversionHr {
    border-top: 2px solid #f09502 !important;
}

.datail-container > hr {
    margin: 20px 0;
    border-top: 2px solid #f09502 !important;
}

.info-proyecto-section {
    width: 100%;
}

.datail-container .atributos {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    border: 1px solid #f09502;
    padding: 15px;
    background-color: rgba(240, 149, 2, 0.05);
}

.datail-container .atributos > p {
    margin: 10px;
    padding: 0;
    color: #ffffff;
}

.datail-container .atributos > p span {
    color: #f09502;
    font-weight: 600;
}

.datail-container .documentation {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
}

.datail-container .documentation > a {
    display: inline-flex;
    align-items: center;
    color: white !important;
    text-decoration: none;
    padding: 12px 20px;
    border: 1px solid #f09502;
    border-radius: 4px;
    background-color: rgba(240, 149, 2, 0.05);
    transition: all 0.3s ease;
}

.datail-container .documentation > a:hover {
    color: #f09502 !important;
    background-color: rgba(240, 149, 2, 0.15);
    border-color: #ffffff;
}

.datail-container .documentation > a i {
    margin-right: 10px;
}

.datail-container > p.h4,
.datail-container-inner > p.h4,
.datail-container-inner .h4 {
    width: 100%;
    color: #f09502;
    font-weight: 600;
}

.dataSale {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    flex-direction: column;
}

.dataSaleLeft {
    justify-content: left;
}

.dataSaleLeft > div {
    padding: 0 !important;
}


.dataSale > div {
    border: 1px solid #f09502;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    background-color: rgba(240, 149, 2, 0.05);
}

.dataSale > div p {
    color: #ffffff;
}

.dataSale .logoPolyscan {
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    border: 1px solid #f09502;
    padding: 12px 16px;
    background-color: rgba(240, 149, 2, 0.1);
    transition: all 0.3s ease;
    border-radius: 4px;
}

.dataSale .logoPolyscan:hover {
    cursor: pointer;
    background-color: rgba(240, 149, 2, 0.2);
    border-color: #ffffff;
}

.dataSale .logoPolyscan img {
    max-width: 40px;
    height: auto;
    margin-right: 10px;
}

.dataSale .logoPolyscan p {
    color: #ffffff;
    margin: 0;
}

.dataSale > div:first-child {
    width: 100%;
}

.dataSale > div span {
    font-weight: bold;
    font-size: 1rem;
}

.dataSale > div:last-child {
    width: 100%;
}

.dataSale .title {
    font-size: 1.5rem;
    margin-bottom: 18px;
    font-weight: bold;
    color: #f09502;
}

.dataSale > div:first-child p:last-child {
    margin-bottom: 0 !important;
}

.dataSale a {
    display: flex;
    justify-content: center;
    width: 100%;
    text-decoration: none;
}

.dataSale .email {
    min-width: 70%;
}

.closeOpen {
    min-width: 50%;
    margin-right: auto;
}

@media (max-width: 768px) {
    .datail-container-inner {
        padding: 15px 20px;
    }

    .gallery {
        width: 100%;
    }

    .gallery .carousel-inner .carousel-item {
        height: auto;
    }
    
    .gallery .carousel-inner .carousel-item img {
        height: auto;
    }

    /* Cambiar a columna en móviles */
    .datail-container .location {
        flex-direction: column;
        gap: 20px;
    }

    .datail-container .location > div:first-child {
        width: 100% !important;
        min-height: 250px;
    }

    .datail-container .location > div:last-child {
        width: 100% !important;
    }

    .datail-container .location iframe {
        min-height: 250px;
    }

    .dataSale > div:first-child {
        width: 100%;
        padding: 0 !important;
        margin-bottom: 35px;
        padding-bottom: 35px !important;
        border-bottom: 1px solid #8282828f !important;
    }
    
    .dataSale > div:last-child {
        width: 100%;
        padding: 0 !important;
        border: none;
    }
}

.modal-close-btn{
    background-color: white !important;
    width: 25px;
    height: 25px;
    padding: 2px;
}

.margin-tittle{
    border-bottom: 2px solid #f09502; 
    padding-left: 0;
    padding-bottom: 15px;
    margin: 0 0 20px 0;
    width: 100%;
}

.margin-tittle .modal-title {
    color: #ffffff;
    font-weight: 600;
}

/* Estilos para viviendas múltiples - Manteniendo consistencia con el diseño original */
.vivienda-info {
    margin-bottom: 20px;
}

.vivienda-header {
    margin-bottom: 10px;
}

.vivienda-title {
    color: #f09502;
    font-weight: bold;
    font-size: 1.1rem;
    margin: 0;
    padding: 8px 0;
    border-bottom: 1px solid #f09502;
}

.vivienda-info .atributos {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    border: 1px solid #f09502;
    padding: 5px;
    margin: 0;
}

.vivienda-info .atributos > p {
    margin: 10px;
    padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/detail-real-estate/detail-real-estate.component.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;;IAEI,oCAAoC;IACpC,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,OAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,wCAAwC;IACxC,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;IAGI,WAAW;IACX,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,yCAAyC;AAC7C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,2BAA2B;IAC3B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA,iCAAiC;IACjC;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,qBAAqB;QACrB,mBAAmB;QACnB,+BAA+B;QAC/B,6CAA6C;IACjD;;IAEA;QACI,WAAW;QACX,qBAAqB;QACrB,YAAY;IAChB;AACJ;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA,uFAAuF;AACvF;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;IACT,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,UAAU;AACd","sourcesContent":["/* Sobrescribir estilos del Material Dialog */\n::ng-deep .mat-mdc-dialog-surface,\n::ng-deep .mdc-dialog__surface {\n    background-color: #181B25 !important;\n    padding: 0 !important;\n    margin: 0 !important;\n}\n\n::ng-deep .mat-mdc-dialog-container {\n    background-color: #181B25 !important;\n    padding: 0 !important;\n}\n\n::ng-deep .cdk-overlay-pane {\n    background-color: #181B25 !important;\n}\n\n.datail-container {\n    background-color: #181B25;\n    min-height: 100vh;\n    padding: 0;\n    color: #ffffff;\n}\n\n.datail-container-inner {\n    background-color: #181B25;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px 40px;\n}\n\n.gallery {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto 45px;\n    border-radius: 8px;\n    overflow: hidden;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.4);\n}\n\n.gallery .carousel-inner {\n    width: 100%;\n    max-height: 600px;\n    overflow: hidden;\n}\n\n.gallery .carousel-inner .carousel-item {\n    width: 100%;\n    height: 600px;\n}\n\n.custom-margin {\n    margin-left: 15px;\n}\n\n.gallery .carousel-inner .carousel-item img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.datail-container .location {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 30px;\n}\n\n.datail-container .location > div {\n    overflow: hidden;\n    padding: 0;\n}\n\n.datail-container .location > div:first-child {\n    width: 30%;\n    flex-shrink: 0;\n}\n\n.datail-container .location > div:last-child {\n    width: 70%;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.datail-container .location > div:first-child iframe {\n    min-height: 300px;\n}\n\n.datail-container .location iframe {\n    width: 100%;\n    height: 100%;\n    min-height: 300px;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);\n}\n\n.location-address {\n    margin-bottom: 20px;\n    text-align: right;\n}\n\n.location-address p {\n    color: #ffffff;\n    font-size: 1rem;\n    line-height: 1.5;\n    text-align: right;\n}\n\n.location-divider {\n    border: none;\n    border-top: 1px solid #f09502 !important;\n    margin: 20px 0;\n    opacity: 0.6;\n}\n\n.location-description {\n    color: #ffffff;\n    line-height: 1.8;\n}\n\n.location-description * {\n    color: #ffffff !important;\n}\n\n.datail-container .location hr.inversionHr {\n    border-top: 2px solid #f09502 !important;\n}\n\n.datail-container > hr {\n    margin: 20px 0;\n    border-top: 2px solid #f09502 !important;\n}\n\n.info-proyecto-section {\n    width: 100%;\n}\n\n.datail-container .atributos {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    border: 1px solid #f09502;\n    padding: 15px;\n    background-color: rgba(240, 149, 2, 0.05);\n}\n\n.datail-container .atributos > p {\n    margin: 10px;\n    padding: 0;\n    color: #ffffff;\n}\n\n.datail-container .atributos > p span {\n    color: #f09502;\n    font-weight: 600;\n}\n\n.datail-container .documentation {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 15px;\n}\n\n.datail-container .documentation > a {\n    display: inline-flex;\n    align-items: center;\n    color: white !important;\n    text-decoration: none;\n    padding: 12px 20px;\n    border: 1px solid #f09502;\n    border-radius: 4px;\n    background-color: rgba(240, 149, 2, 0.05);\n    transition: all 0.3s ease;\n}\n\n.datail-container .documentation > a:hover {\n    color: #f09502 !important;\n    background-color: rgba(240, 149, 2, 0.15);\n    border-color: #ffffff;\n}\n\n.datail-container .documentation > a i {\n    margin-right: 10px;\n}\n\n.datail-container > p.h4,\n.datail-container-inner > p.h4,\n.datail-container-inner .h4 {\n    width: 100%;\n    color: #f09502;\n    font-weight: 600;\n}\n\n.dataSale {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: stretch;\n    flex-direction: column;\n}\n\n.dataSaleLeft {\n    justify-content: left;\n}\n\n.dataSaleLeft > div {\n    padding: 0 !important;\n}\n\n\n.dataSale > div {\n    border: 1px solid #f09502;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-start;\n    background-color: rgba(240, 149, 2, 0.05);\n}\n\n.dataSale > div p {\n    color: #ffffff;\n}\n\n.dataSale .logoPolyscan {\n    display: inline-flex;\n    justify-content: flex-start;\n    align-items: center;\n    border: 1px solid #f09502;\n    padding: 12px 16px;\n    background-color: rgba(240, 149, 2, 0.1);\n    transition: all 0.3s ease;\n    border-radius: 4px;\n}\n\n.dataSale .logoPolyscan:hover {\n    cursor: pointer;\n    background-color: rgba(240, 149, 2, 0.2);\n    border-color: #ffffff;\n}\n\n.dataSale .logoPolyscan img {\n    max-width: 40px;\n    height: auto;\n    margin-right: 10px;\n}\n\n.dataSale .logoPolyscan p {\n    color: #ffffff;\n    margin: 0;\n}\n\n.dataSale > div:first-child {\n    width: 100%;\n}\n\n.dataSale > div span {\n    font-weight: bold;\n    font-size: 1rem;\n}\n\n.dataSale > div:last-child {\n    width: 100%;\n}\n\n.dataSale .title {\n    font-size: 1.5rem;\n    margin-bottom: 18px;\n    font-weight: bold;\n    color: #f09502;\n}\n\n.dataSale > div:first-child p:last-child {\n    margin-bottom: 0 !important;\n}\n\n.dataSale a {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    text-decoration: none;\n}\n\n.dataSale .email {\n    min-width: 70%;\n}\n\n.closeOpen {\n    min-width: 50%;\n    margin-right: auto;\n}\n\n@media (max-width: 768px) {\n    .datail-container-inner {\n        padding: 15px 20px;\n    }\n\n    .gallery {\n        width: 100%;\n    }\n\n    .gallery .carousel-inner .carousel-item {\n        height: auto;\n    }\n    \n    .gallery .carousel-inner .carousel-item img {\n        height: auto;\n    }\n\n    /* Cambiar a columna en móviles */\n    .datail-container .location {\n        flex-direction: column;\n        gap: 20px;\n    }\n\n    .datail-container .location > div:first-child {\n        width: 100% !important;\n        min-height: 250px;\n    }\n\n    .datail-container .location > div:last-child {\n        width: 100% !important;\n    }\n\n    .datail-container .location iframe {\n        min-height: 250px;\n    }\n\n    .dataSale > div:first-child {\n        width: 100%;\n        padding: 0 !important;\n        margin-bottom: 35px;\n        padding-bottom: 35px !important;\n        border-bottom: 1px solid #8282828f !important;\n    }\n    \n    .dataSale > div:last-child {\n        width: 100%;\n        padding: 0 !important;\n        border: none;\n    }\n}\n\n.modal-close-btn{\n    background-color: white !important;\n    width: 25px;\n    height: 25px;\n    padding: 2px;\n}\n\n.margin-tittle{\n    border-bottom: 2px solid #f09502; \n    padding-left: 0;\n    padding-bottom: 15px;\n    margin: 0 0 20px 0;\n    width: 100%;\n}\n\n.margin-tittle .modal-title {\n    color: #ffffff;\n    font-weight: 600;\n}\n\n/* Estilos para viviendas múltiples - Manteniendo consistencia con el diseño original */\n.vivienda-info {\n    margin-bottom: 20px;\n}\n\n.vivienda-header {\n    margin-bottom: 10px;\n}\n\n.vivienda-title {\n    color: #f09502;\n    font-weight: bold;\n    font-size: 1.1rem;\n    margin: 0;\n    padding: 8px 0;\n    border-bottom: 1px solid #f09502;\n}\n\n.vivienda-info .atributos {\n    width: 100%;\n    display: flex;\n    justify-content: flex-start;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    border: 1px solid #f09502;\n    padding: 5px;\n    margin: 0;\n}\n\n.vivienda-info .atributos > p {\n    margin: 10px;\n    padding: 0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
